import { Stack } from "@mui/material";
import { UsersTable } from "Clients/Components/UsersTable";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const ClientsPage: React.FunctionComponent = () => {
	return (
		<AuthenticatedLayout title="Uživatelé">
			<Stack spacing={2}>
				<UsersTable />
			</Stack>
		</AuthenticatedLayout>
	);
};
